var _style, _rect, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKardabelLogoSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 180.2",
    style: {
      enableBackground: "new 0 0 250 180.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#0C7189;}\r\n\t.st1{fill:#EBCA94;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -26.1,
    className: "st0",
    width: 354,
    height: 235
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000094614655247317061910000009299331444409717152_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ardabel_00000136377052940624317870000014759726589963172536_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.4,97.6c-5.6-7.3-14.6-12-24-12c-16.7,0-30.4,13.7-30.4,30.4s13.3,30.4,30.4,30.4h24h6.4V116 C247.4,109.2,245.3,102.7,241.4,97.6z M235.4,116h-1.7h-7.3c-5.1,0-9-3.9-9-9c0-5.1,3.9-9,9-9c3,0,5.6,1.3,7.3,3.4 c1.3,1.7,1.7,3.4,1.7,5.6V116z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "K_00000025400954016292412730000008614040802157610163_",
    className: "st2",
    d: "M172.5,116c0-27.4,17.5-30.8,77.5-88.2 c-64.2,46.7-72.8,45.8-77.5,44.5c-7.3-2.6-14.6-44.5-14.6-44.5v49.2V146l61.2,30.4C219.2,176.8,172.5,142.1,172.5,116z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "trio"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 175,
    height: 175,
    xlinkHref: "E3615A0E.png",
    transform: "matrix(1 0 0 1 -12 -9.8)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.9,8.2c-6.8,2.6-11.1,6.4-12.8,12C82.7,30,89.5,42,89.5,42l54.8,95.4v-110c0,0,0-13.7-8.1-20.5 c-3-2.6-7.3-4.3-12.4-4.3c-1.7,0-3.4,0-5.1,0.4l-9,2.1L98.9,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6,101.5l-3,10.3l-2.6,9.4c-1.3,7.3,0,13.3,3.9,17.1c6,6.8,17.1,7.7,20.5,8.1l0,0h109.6l-95-54.8 c0,0-7.3-4.3-15.4-4.3c-2.1,0-4.3,0.4-6.4,0.9C12.5,89.9,8.6,94.6,6,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1,51.8c-4.7,5.6-6.4,11.1-5.1,16.7c2.1,10.3,13.7,17.1,13.7,17.1l95,55.2l-55.2-95 c0,0-6.8-12-17.1-13.7l0,0c-0.9,0-2.1-0.4-3-0.4c-4.7,0-9.4,2.1-14.1,6l-6.4,6.4L35.1,51.8z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKardabelLogoSimple);
export default __webpack_public_path__ + "static/media/kardabel_logo-simple.2beaf801cc31a10f684f9cbe155a4eb8.svg";
export { ForwardRef as ReactComponent };